import {
    useGetBrand,
    useGetChain,
    useGetDeliveryService,
    useGetOnSite,
    useGetRespondentType,
    useGetSegment
} from "@core/CommonDataContext";
import { useCallback } from "react";
import { AmongPayload } from "@vms/SelectAmong/useGetAmongPayload";

export enum AmongType {
    RespondentType,
    Chain,
    Restaurant,
    CStore,
    Supermarket,
    Hotels,
    Brand,
    Segment,
    OnSite,
    Delivery,
}

export function useGetAmongTypeData() {
    const getRespondentType = useGetRespondentType();
    const getChain = useGetChain();
    const getBrand = useGetBrand();
    const getSegment = useGetSegment();
    const getOnSite = useGetOnSite();
    const getDeliveryService = useGetDeliveryService();

    return useCallback(
        (id: number, type: AmongType) => {
            let getter;

            switch (type) {
                case AmongType.RespondentType: {
                    getter = getRespondentType;
                    break;
                }
                case AmongType.Chain: {
                    getter = getChain;
                    break;
                }
                case AmongType.Brand: {
                    getter = getBrand;
                    break;
                }
                case AmongType.Segment: {
                    getter = getSegment;
                    break;
                }
                case AmongType.OnSite: {
                    getter = getOnSite;
                    break;
                }
                case AmongType.Delivery: {
                    getter = getDeliveryService;
                    break;
                }
            }

            return getter ? {
                id,
                type,
                name: getter(id)?.name ?? '',
            } : null;
        },
        [getRespondentType, getChain, getBrand, getSegment, getOnSite, getDeliveryService]
    );
}

export function getAmongTypeKey(id: number, type: AmongType) {
    return `${type}-${id}`;
}

export function useGetSelectedAmongTypes() {
    return useCallback(
        (amongPayload: AmongPayload) => [
            ...(amongPayload.respondentTypes ?? []).map(i => ({
                id: i,
                type: AmongType.RespondentType
            })),
            ...(amongPayload.chains ?? []).map(i => ({
                id: i,
                type: AmongType.Chain
            })),
            ...(amongPayload.segments ?? []).map(i => ({
                id: i,
                type: AmongType.Segment
            })),
            ...(amongPayload.cpgBrands ?? []).map(i => ({
                id: i,
                type: AmongType.Brand
            })),
            ...(amongPayload.onSites ?? []).map(i => ({
                id: i,
                type: AmongType.OnSite
            })),
            ...(amongPayload.deliveryServices ?? []).map(i => ({
                id: i,
                type: AmongType.Delivery
            })),
        ],
        []
    );
}